import { cva } from "class-variance-authority";

export const registerFeedbackPageStyles = cva([
  "flex w-full flex-col",
]);

export const registerFeedbackContentStyles = cva([
  "mx-auto flex w-full max-w-[760px] flex-col items-stretch px-4 pb-8 pt-6",
  "md:items-center md:pt-10",
]);
